import { ILicenceProfileResponse } from "../../api/ILicenceProfile";
import Page404 from "../../pages/auth/Page404";
import Page500 from "../../pages/auth/Page500";
import Loading from "../Loading";

const IsLicenceProfileReady = (
  licenceProfileResponse?: ILicenceProfileResponse
) => {
  if (!licenceProfileResponse) {
    return false;
  }

  if (licenceProfileResponse.response.httpStatusCode === 404) {
    return false;
  }

  if (!licenceProfileResponse.licenceProfile) {
    return false;
  }

  return true;
};

const GetLicenceProfileNotReadyComponent = (
  licenceProfileResponse?: ILicenceProfileResponse
) => {
  if (!licenceProfileResponse) {
    return <Loading />;
  }

  if (licenceProfileResponse.response.httpStatusCode === 404) {
    return <Page404 />;
  }

  if (!licenceProfileResponse.licenceProfile) {
    return <Page500 />;
  }

  return <Loading />;
};

export { IsLicenceProfileReady, GetLicenceProfileNotReadyComponent };
